import 'css-chunksrc/client/common/filterMenu/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_cixhm_1",
  "checked": "_checked_cixhm_13"
};